module.exports = __webpack_public_path__ + "img/O que fazer com restos de poda 1.0619a28a.webp";